;
var sprite = require("/tmp/build_28b142ae/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_Share_62144a1734f2553e951bbe5fe67411ac\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <g> <polygon points=\"60.704,27.601 60.704,31.882 74.034,31.882 74.034,82.992 25.966,82.992 25.966,31.882 39.297,31.882 \r\n\t\t\t39.297,27.601 21.392,27.601 21.392,87.273 78.608,87.273 78.608,27.601 \t\t\"/> <polygon points=\"47.762,9.482 47.762,53.293 52.238,53.293 52.238,9.482 64.401,21.646 67.418,18.63 50,1.211 32.583,18.63 \r\n\t\t\t35.6,21.646 \t\t\"/> </g> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_Share_62144a1734f2553e951bbe5fe67411ac");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_Share.svg
// module id = 1416
// module chunks = 0